export default "__VITE_ASSET__D4wkzCM2__"